<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Nomina de usuarios</h6>

            <!-- Columna de búsqueda -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar usuario..." @input="onSearchInput" />
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                      laborado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                      pagado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                      pendiente</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm" v-if="value.payment==0">
                        N/A
                        </h6>
                      <h6 class="mb-0 text-sm" v-if="value.payment==1">
                        {{
                        parseFloat(value.production_users_sum_total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits:
                            2, maximumFractionDigits: 2
                        }) }}
                        </h6>
                       
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">{{
                        parseFloat(value.production_payments_sum_total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}</h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm" v-if="value.payment==0">
                        N/A
                        </h6>
                      <h6 class="mb-0 text-sm" v-if="value.payment==1">
                         {{ (parseFloat(value.production_users_sum_total ?? 0) - parseFloat(value.production_payments_sum_total ?? 0)).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                          </h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <div class="d-flex justify-content-center align-items-center gap-2">
                        <a @click="viewProductions(value)"
                          class="text-info font-weight-bold text-xs cursor-pointer d-flex align-items-center gap-1"
                          data-toggle="tooltip" data-original-title="Ver historial de trabajos">
                          <i class="fas fa-tasks"></i>
                          <span>Ver Tareas</span>
                        </a>

                        <a @click="viewPaid(value)" 
                          class="text-success font-weight-bold text-xs cursor-pointer d-flex align-items-center gap-1"
                          data-toggle="tooltip" data-original-title="Ver historial de pagos">
                          <i class="fas fa-receipt"></i>
                          <span>Ver Pagos</span>
                        </a>
                      </div>
                    </td>

                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: this.$store.getters['users/searchQuery'] || '',
      searchTimeout: null,
    };
  },
  computed: {
    ...mapGetters('users', ['allUsers', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.users.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.users.lastPage; // Obtiene la última página
    },
    data() {
      return this.allUsers; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['users/links']; // Retorna los links
    },
  },
  methods: {
    onSearchInput() {
      this.$store.commit('users/SET_SEARCH_QUERY', this.searchQuery);
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchData(null);
      }, 400);
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('users/fetchUsers', params);
    },
    async viewPaid(userData) {
      this.$router.push({ name: "Nomina Payments", params: userData });
    },
    async viewProductions(userData) {
      this.$router.push({ name: "Nomina Productions", params: userData });
    },

  },
  mounted() {
    if (this.searchQuery) {
      this.fetchData(null);
    } else {
      this.fetchData();
    }
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>